module.exports = __webpack_public_path__ + "img/FR17789.edd83b9b.png";